import SparklesIconPath from "@ingka/ssr-icon/paths/sparkles";

export default SparklesIconPath;
